// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FAQCard_wrapper__3G4bC","content":"FAQCard_content__YMpN8","button":"FAQCard_button__3sExe","open":"FAQCard_open__ovAkE"};